module.exports = __webpack_public_path__ + "img/tiki-icon.64256d8c.png";